import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { useCaptureError } from '../../../hooks/useCaptureError';
import { jsx as _jsx } from "react/jsx-runtime";
export function EnterpriseManagedAuthErrorState({
  error
}) {
  useCaptureError(error, {
    message: 'Error fetching EMA status'
  });
  return /*#__PURE__*/_jsx(Alert, {
    type: "danger",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app-governance-lib.errorBoundary.default.title"
    }),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app-governance-lib.advanced.ema.error"
    })
  });
}